import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './vuetify';
import mixin from './mixin';
import './vueHead';
import './vue2Storage';
import './vueGoogleCharts';
import './veeValidate';
import './font.css';
import './components';
import './layouts';
import './plugins';
import './registerServiceWorker';

Vue.mixin(mixin)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
